/**
 * 达人订单详情页 - 状态提醒条
 */

interface StatusAlertProps {
  visible: boolean;
  text: string;
  type: "warning" | "info" | "success";
}

export default function StatusAlert({ visible, text, type }: StatusAlertProps) {
  if (!visible) return null;

  const styleMap = {
    warning: {
      bg: "#FFF7ED",
      border: "#FED7AA",
      icon: "ri-time-line",
      color: "#EA580C",
    },
    info: {
      bg: "#EFF6FF",
      border: "#BFDBFE",
      icon: "ri-information-line",
      color: "#2563EB",
    },
    success: {
      bg: "#ECFDF5",
      border: "#A7F3D0",
      icon: "ri-checkbox-circle-line",
      color: "#059669",
    },
  };

  const s = styleMap[type];

  return (
    <div
      className="mx-4 mt-3 px-4 py-3 rounded-xl flex items-center gap-2"
      style={{ background: s.bg, border: `1px solid ${s.border}` }}
    >
      <i
        className={`flex-shrink-0 ${s.icon}`}
        style={{ fontSize: 14, color: s.color }}
      />
      <span
        className="text-xs font-medium"
        style={{ color: s.color }}
      >
        {text}
      </span>
    </div>
  );
}
